// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo {\n  height: 32px;\n  line-height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  margin: 16px;\n  color: white;\n  text-align: center;\n}\n.ant-layout {\n  min-height: 100vh;\n}\n.ant-layout-footer {\n  text-align: center;\n}\n.lazy-loading {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
